export const enum AddInsuredModalSteps {
  SearchExistingUser,
  InsuredDetails,
  AddressDetails,
  ContactInformation,
  PaymentInformation,
}
